import { Button, ButtonLink, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  margin-bottom: 24px;
`;

export const WatchlistManagerTitleContainer = styled.div<{ $inModal: boolean }>`
  display: flex;
  align-items: center;
  margin-top: ${props => props.$inModal && '-18px'};
`;

export const Title = styled.h4`
  ${typographyV2.titleLg};
`;

export const StyledButton = styled(Button)`
  path {
    fill: var(--icon-primary);
  }
`;

export const Description = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const StyledButtonLink = styled(ButtonLink)`
  & > span {
    gap: 4px;
  }
`;
